function RecordMovementdetailCtrl($rootScope) {

  // ViewModel
  const vm = this;

    

}

export default {
  name: 'RecordMovementdetailCtrl',
  fn: RecordMovementdetailCtrl
};
